import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientRepresentativeSaveCompanyNameMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { SaveCompanyNameParam } from 'api/types/params';

import { parseLegalClientRepresentative } from '../helpers';

export const useLegalClientRepresentativeSaveCompanyName = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientRepresentativeSaveCompanyNameMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientRepresentativeCompanyName
      ? parseLegalClientRepresentative(
          data.legalClientRepresentativeCompanyName
        )
      : undefined,
    loading,
    error,
    saveCompanyName: useCallback(
      async (id: string, params: SaveCompanyNameParam) => {
        const res = await handle({
          variables: {
            id,
            input: params,
          },
        });
        return res?.data?.legalClientRepresentativeCompanyName
          ? parseLegalClientRepresentative(
              res.data.legalClientRepresentativeCompanyName
            )
          : undefined;
      },
      [handle]
    ),
  };
};
